// extracted by mini-css-extract-plugin
module.exports = {"link":"LinkToPage_link__3-Bga"};